import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';

import { SettingsService } from '../../core/settings/settings.service';
import { ThemesService } from '../../core/themes/themes.service';
import { TranslatorService } from '../../core/translator/translator.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';

@Component({
    selector: 'app-offsidebar',
    templateUrl: './offsidebar.component.html',
    styleUrls: ['./offsidebar.component.scss']
})
export class OffsidebarComponent implements OnInit, OnDestroy {

    currentTheme: any;
    selectedLanguage: string;

    langs: Promise<{ code: string, text: string }[]>;
    langsSubscription: Subscription;


    constructor(
        public settings: SettingsService,
        public themes: ThemesService,
        public translator: TranslatorService,
        public elem: ElementRef,
        public translateService: TranslateService
    ) {
    }

    ngOnInit() {
        this.langsSubscription = this.translator.availableLangs.subscribe(langs => this.langs = Promise.resolve(langs));

        if (Meteor.user()) {
            this.init();
        } else {
            Accounts.onLogin(() => this.init());
        }

        this.anyClickClose();
    }

    ngOnDestroy() {
        document.removeEventListener('click', this.checkCloseOffsidebar);
        if (this.langsSubscription) this.langsSubscription.unsubscribe();
    }

    init() {
        const user: Meteor.User = Meteor.user();
        this.selectedLanguage = this.translator.useLanguage();
        this.currentTheme = this.settings.getLayoutSetting("theme");
    }

    setTheme() {
        // if (Meteor.user()) {
        //     Meteor.users.update({ _id: Meteor.userId() }, {
        //         $set: {
        //             "profile.layout.theme": this.currentTheme
        //         }
        //     });
        // }
        this.settings.setLayoutSetting("theme", this.currentTheme);
    }

    setLang() {
        // if (Meteor.user()) {
        //     Meteor.users.update({ _id: Meteor.userId() }, {
        //         $set: {
        //             "profile.lang": this.selectedLanguage
        //         }
        //     });
        // }
        this.settings.setUserSetting("lang", this.selectedLanguage);
    }

    anyClickClose() {
        document.addEventListener('click', this.checkCloseOffsidebar.bind(this), false);
    }

    checkCloseOffsidebar(e) {
        const contains = (this.elem.nativeElement !== e.target && this.elem.nativeElement.contains(e.target));
        if (!contains && this.settings) {
            this.settings.setLayoutSetting('offsidebarOpen', false);
        }
    }
}
